import { QuestionType2UIConfig } from "../../../../../components/ui/question-type2-ui";
import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../../../../../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { VideoSegmentItem, SingleVideoSegmentItem } from "../../../../../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { ScoringType } from "../../../../../misc/tools";
import { GameBaseScenario } from "../../../../GameBaseScenario";
import Scenario3IncorrectPtAdmitted, { scenario3IncorrectPtAdmittedAudioCaching, scenario3IncorrectPtAdmittedVideoSegments } from "../../../scenario3-incorrect-pt-admitted";
import { IncorrectPtAdmittedComponentsStep1ComponentMainConfig, IncorrectPtAdmittedComponentsStep1ComponentPart1Config } from "../incorrect-pt-admitted-components-step1";

export default class IncorrectPtAdmittedComponentsStep1Part1 extends BaseScenarioPart<GameBaseScenario> {
	private stepName = 'Step 2'
	private get config(): IncorrectPtAdmittedComponentsStep1ComponentPart1Config {
		return this.mainConfig.part1Config;
	}
	constructor(scenario: GameBaseScenario, private onDone: () => void, private id: string, private mainConfig: IncorrectPtAdmittedComponentsStep1ComponentMainConfig) {
		super(scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.section1();
	}

	public section1() {
		const context = this;
        this.mainConfig.scenario.setAreaForCurrentScenario(6);
		this.mainConfig.scenario.uiWrapper.displayMixedMediaUI({
			title: this.mainConfig.scenario.props.name,
			subtitle: this.stepName,
			htmlData: `
				<p class="default-text add-pad">For the substitution test, you approach other employees and inquire as to whether they would do the same 
				thing in similar circumstances.<br/><br/>
				Clerk #1: I always check the patient’s identity. Either I verbally 
				ask them or check their wristband.<br/><br/>
				Clerk #2: The protocol is clear. However, I often find it extremely 
				challenging to keep the line moving when I’m by myself. There are some days when the line is 
				out the door, and the Veterans get very angry. We are overwhelmed.<br/><br/>
				Clerk #3: I have to admit and say I don’t always check the full 
				name and full social. It’s just too busy and I’m trying to move as fast as I can.</p>
			`,
			okButton: 'Continue',
			talkingVideoSrc: scenario3IncorrectPtAdmittedVideoSegments.getItemByKey('MixedMedia').src,
			talkingVideoChapterId: scenario3IncorrectPtAdmittedVideoSegments.getItemByKey('MixedMedia').chapterIds[0],
			onContinueClicked: () => {
				context.section2();
			}
		})
	}

	public section2() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType2UI({
			audioUrl: scenario3IncorrectPtAdmittedAudioCaching.getItemByKey(scenario3IncorrectPtAdmittedAudioCaching.audioKeys.question3).src,
			title: this.mainConfig.scenario.props.name,
			subtitle: (this.stepName + ' - Question 1'),
			isYesCorrect: true,
			correctFeedback: `
				<p class="default-text">Correct. The other clerks stated they often encounter similar 
				problems about feeling rushed and the Veterans complaining.</p>
			`,
			wrongFeedback: `
				<p class="default-text">This is not the best option. The other clerks stated they 
				often encounter problems with feeling rushed.</p>
			`,
			question: 'Given the information received from staff interviews, is it reasonable to conclude that a systems or cultural issue exists, and other employees in that work area would behave the same way in a similar situation?',
			onSubmitClicked: (isCorrect: boolean, feedback: string, selectedTitle: string, parentQuestion: QuestionType2UIConfig) => {
				const mentorInfo = scenario3IncorrectPtAdmittedVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType2(isCorrect, feedback, selectedTitle, (this.stepName + ' - Question 1 '), parentQuestion, () => {
					context.section3();
				}, () => {
					context.section3();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[6], mentorInfo.chapterIds[7]);
			}
		}, 2);
	}

	public section3() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType1UI({
			title: this.mainConfig.scenario.props.name,
			subtitle: (this.stepName + ' - Question 2'),
			audioUrl: scenario3IncorrectPtAdmittedAudioCaching.getItemByKey(scenario3IncorrectPtAdmittedAudioCaching.audioKeys.question4).src,
			questionTitle: 'Based on the substitution test, the accountability for this action…',
			options: [
				{
					title: 'Lies completely with the employee.',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">This is not the best option. The substitution test demonstrates that other 
						employees would make a similar choice and there are system or cultural issues identified.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'Is shared between the employee and organizational leadership.',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">Correct. The substitution test demonstrates that other employees 
						would make a similar choice and there are system or cultural issues identified.</p>
					`,
					isCorrect: true,
					score: ScoringType.good
				},
				{
					title: 'Lies solely with the leadership.',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">This is not the best option. The substitution test demonstrates 
						that there are system or cultural issues identified but also accountability for the employee’s actions.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				}
			],
			
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario3IncorrectPtAdmittedVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType1(selectedChoices[0], (this.stepName + ' - Question 2 '), parentQuestionConfig, () => {
					this.onDone();
				}, () => {
					this.onDone();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[8], mentorInfo.chapterIds[9], mentorInfo.chapterIds[10], 'Lies completely with the employee.');
			}
		}, 3);
	}
}